import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=73586aad&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73586aad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73586aad')) {
      api.createRecord('73586aad', component.options)
    } else {
      api.reload('73586aad', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=73586aad&scoped=true&", function () {
      api.rerender('73586aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KrC0rzdYyKR7/JS/comp/Accordion.vue"
export default component.exports